import { create } from '@ebay/nice-modal-react';

import useCreateWorkspaceDataContext from './CreateWorkspaceDataProvider/useCreateWorkspaceDataContext';
import withCreateWorkspaceDataProvider from './CreateWorkspaceDataProvider/withCreateWorkspaceDataProvider';
import { CreateWorkspaceInitOptions, CreateWorkspaceStepsEnum } from './types';
import WorkspaceCreateStep from './WorkspaceCreateStep/WorkspaceCreateStep';
import WorkspaceInviteStep from './WorkspaceInviteStep/WorkspaceInviteStep';
import WorkspaceRoleCreate from './WorkspaceRoleCreate/WorkspaceRoleCreate';
import WorkspaceSuccessStep from './WorkspaceSuccessStep/WorkspaceSuccessStep';

type CreateWorkspaceModalProps = {
  onGoBack?: () => void;
} & CreateWorkspaceInitOptions;

const CreateWorkspaceModal = create(
  withCreateWorkspaceDataProvider(({ onGoBack }: CreateWorkspaceModalProps) => {
    const { currentStep, setCurrentStep, createdWorkspaceId } = useCreateWorkspaceDataContext();

    switch (currentStep) {
      case CreateWorkspaceStepsEnum.CREATE:
        return <WorkspaceCreateStep onGoBack={onGoBack} />;

      case CreateWorkspaceStepsEnum.INVITE:
        return <WorkspaceInviteStep />;

      case CreateWorkspaceStepsEnum.CREATE_ROLES:
        return (
          <WorkspaceRoleCreate
            onGoBack={() => setCurrentStep(CreateWorkspaceStepsEnum.INVITE)}
            workspaceId={createdWorkspaceId}
          />
        );

      case CreateWorkspaceStepsEnum.SUCCESS:
        return <WorkspaceSuccessStep />;

      default:
        throw new Error(`Reached unknown currentStep value: ${currentStep}`);
    }
  })
);

export default CreateWorkspaceModal;
